import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedModule} from '@shared/shared.module';
import {RouterModule} from '@angular/router';
import {CommandService} from '@core/services/command.service';
import {PlatformApiProvider} from '@shared/services/platform-api-provider';
import {PlatformCommand} from '@shared/commands/command-base';
import {platformRoutes} from '@features/platform/platform.routes';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(platformRoutes),
  ]
})
export class PlatformModule {
  constructor(
    protected commandService: CommandService,
    protected platformApiProvider: PlatformApiProvider,
  ) {
    const command = new PlatformCommand('SharePlatformLinkCommand', 'SecurityApi');
    this.commandService.registrPlatformLinkCommand('/share', command);
    platformApiProvider.registerDefault('SecurityApi', '/share');
  }
}
